import { type PaymentsListItem } from "../types/PaymentsListItem";

export function isReversalPaymentItem(item: PaymentsListItem): boolean {
  return item.attributes.amountInCents < 0;
}
